import { render, staticRenderFns } from "./MultiItemSwiper.vue?vue&type=template&id=23bfd95c&scoped=true"
import script from "./MultiItemSwiper.vue?vue&type=script&lang=js"
export * from "./MultiItemSwiper.vue?vue&type=script&lang=js"
import style0 from "./MultiItemSwiper.vue?vue&type=style&index=0&id=23bfd95c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bfd95c",
  null
  
)

export default component.exports